module.exports = __webpack_public_path__ + "img/devices-mobile-vtt-2.fec531a5.png";